// @ts-nocheck
const TasksSkeleton = () => {

    return (
        <div>Es lädt...</div>
    )
}

export default TasksSkeleton